import { Assignment } from "@livechat/design-system-icons";

import { AgentAssignmentFilterEnum } from "constants/filters";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

import { AgentAssignmentFilterLabels } from "./AgentAssignmentFilter";

export const agentAssignmentFilterConfig: IFilterConfig = {
  title: "Assignment",
  icon: Assignment,
  multiple: false,
  getFilterLabelValues: (filterValues: AgentAssignmentFilterEnum): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    return [
      {
        key: filterValues[0],
        label: AgentAssignmentFilterLabels[filterValues],
      },
    ];
  },
};
